import { render, staticRenderFns } from "./takecomplaints.vue?vue&type=template&id=1a253fe6&"
import script from "./takecomplaints.vue?vue&type=script&lang=js&"
export * from "./takecomplaints.vue?vue&type=script&lang=js&"
import style0 from "./takecomplaints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports